import axios from 'axios'
import { RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { salvarCacheFormasPagamento, carregarCacheFormasPagamento } from '../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function recuperarFormaPagamentosDesativados (idEmpresa) {
  const url = `${URL}/formapagamento/empresa/${idEmpresa}/pagamentos-desativados`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheFormasPagamento(idEmpresa, response.data);
      return dispatch({ type: RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const cache = carregarCacheFormasPagamento(idEmpresa);
        return dispatch({ type: RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS, payload: { data: cache || [] } });
      }
      throw erro;
    });
}
